import { updateFields } from '../../firebase/firebase.utils'; 
import { Comment } from '../../models/domain/comment';

export const onUpdateDeleteCommentFile = async(firebase, commentId) => {


    console.log('onUpdateCommentText() > ()', commentId);

    try {

        if(!commentId ){
            console.warn('No comment info! Aborting updating ...');
            return void 0;
        }

        const now = firebase.database.ServerValue.TIMESTAMP;
        const path = `${commentId}`;

        const upData = {
            significantAttachmentId: null,
            attachments: null,
            lastUpdatedUTime: now,
            isEdited: now,
        }

        await updateFields(firebase, Comment.path(path), upData);

    } catch (e) {

        console.error('onUpdateCommentText() > catch{}', e);

    }

};
